import { ComponentRef, EventEmitter } from '@angular/core';
import { FicScreenPortalComponent } from './fic-screen-portal.component';
import { Subject } from 'rxjs';

export class FicScreenRefModel<T, TRes> {
    screenComponentRef: ComponentRef<FicScreenPortalComponent>;

    beforeClose = new EventEmitter<FicScreenRefBeforeCloseEvent>();
    onClose = new Subject<TRes>();
    afterClosed = new Subject<TRes>();

    close(result?: TRes) {
        const prevent = this.emitBeforeClose();
        if (prevent) {
            return;
        }

        return this.processClose(result);
    }

    // return true if close process should be terminated
    emitBeforeClose() {
        const event = new FicScreenRefBeforeCloseEvent();
        this.beforeClose.emit(event);
        return event.defaultPrevented;
    }

    processClose(result?: TRes) {
        this.beforeClose.complete();
        this.onClose.next(result);
        this.onClose.complete();

        this.screenComponentRef.instance.close().then(() => {
            this.screenComponentRef.destroy();
            this.afterClosed.next(result);
            this.afterClosed.complete();
            return result;
        });
    }
}

export class FicScreenRefBeforeCloseEvent {
    preventDefault() {
        this._defaultPrevented = true;
    }

    private _defaultPrevented: boolean = false;

    get defaultPrevented() {
        return this._defaultPrevented;
    }
}
